var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29169 6.58335V4.85836C2.29169 3.43336 3.44169 2.29169 4.85836 2.29169H6.65836",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5834 6.58335V4.85836C17.5834 3.43336 16.4334 2.29169 15.0167 2.29169H13.2167",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29175 13.35V15.075C2.29175 16.5 3.44175 17.6416 4.85842 17.6416H6.65842",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5834 13.35V15.075C17.5834 16.5 16.4334 17.6416 15.0167 17.6416H13.2167",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83354 8.91671C10.9703 8.91671 11.8919 7.99517 11.8919 6.85838C11.8919 5.7216 10.9703 4.80005 9.83354 4.80005C8.69676 4.80005 7.77521 5.7216 7.77521 6.85838C7.77521 7.99517 8.69676 8.91671 9.83354 8.91671Z",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68353 14.6084V13.4334C5.68353 12.0667 6.79186 10.9667 8.15019 10.9667H11.8419C13.2085 10.9667 14.3085 12.0751 14.3085 13.4334V14.6084",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFeedback);
export default __webpack_public_path__ + "static/media/ic_feedback.2cdc381647e157eb4189ab05b7f3aa1b.svg";
export { ForwardRef as ReactComponent };